"use client"

import { useEffect } from "react"
import { trackOaiq } from "@/lib/openai-pixel"

const THRESHOLD_MS = 45_000
const STORAGE_KEY = "oaiq_engaged_45s_sent"

// Envoie contents_viewed au pixel ChatGPT Ads après 45 s d'onglet visible et au
// moins une vraie interaction, une seule fois par session. Événement standard et
// non personnalisé : seuls les standards peuvent servir d'objectif de conversion.
export function EngagementTracker() {
  useEffect(() => {
    try {
      if (sessionStorage.getItem(STORAGE_KEY)) return
    } catch {}

    let visibleMs = 0
    let interacted = false
    let sent = false

    const send = () => {
      if (sent || !interacted || visibleMs < THRESHOLD_MS || !window.oaiq) return
      sent = true
      trackOaiq("contents_viewed", { type: "contents" })
      try {
        sessionStorage.setItem(STORAGE_KEY, "1")
      } catch {}
      cleanup()
    }

    const tick = window.setInterval(() => {
      if (document.visibilityState !== "visible") return
      visibleMs += 1000
      send()
    }, 1000)

    const onInteraction = () => {
      interacted = true
      send()
    }
    const events = ["scroll", "click", "touchstart"] as const
    events.forEach((e) => window.addEventListener(e, onInteraction, { passive: true }))

    function cleanup() {
      window.clearInterval(tick)
      events.forEach((e) => window.removeEventListener(e, onInteraction))
    }

    return cleanup
  }, [])

  return null
}
